/***************************************************************************/
"use client";
/***************************************************************************/

import i18next from "i18next";
import resourcesToBackend from "i18next-resources-to-backend";
import { initReactI18next } from "react-i18next";

const fallbackLng = "en";
const languages = [fallbackLng, "de"];
const defaultNS: string[] = ["root", "error"];

i18next
  .use(initReactI18next)
  .use(
    resourcesToBackend((language: string, namespace: string) => {
      return import(`../../locales/${language}/${namespace}.json`);
    }),
  )
  .init({
    supportedLngs: languages,
    fallbackLng,
    fallbackNS: defaultNS,
    defaultNS,
    ns: defaultNS,
    debug: true,
    interpolation: {
      escapeValue: false,
    },
    lng: undefined,
    detection: {
      order: ["path", "htmlTag", "cookie", "navigator"],
    },
    preload: [],
    react: {
      useSuspense: true,
    },
  });
